import { AccountTypes } from '@/constants/user/accountTypes'
import { CustomerTypes } from '@/constants/user/roles'
import Avatar from '@/models-ts/user/Avatar'

export default class UserInfo {
  id: number
  name: string
  type: AccountTypes
  avatar: Avatar
  reviewsCount: number
  avgReviews: string
  is_customer_verified: boolean
  customerType?: CustomerTypes
  bio?: string | null

  constructor(data: UserInfo) {
    Object.assign(this, data)
  }

  static fromServer(data: LX.UserInfo) {
    return new UserInfo({
      id: data.id,
      name: data.name,
      avatar: Avatar.fromServer(data.avatar),
      type: data.type,
      avgReviews: (data.profile?.avg_reviews || 0).toFixed(2),
      reviewsCount: data.reviews_count,
      is_customer_verified: Number(data.is_customer_verified) === 1,
      customerType: data.profile?.type || CustomerTypes.INDIVIDUAL,
      bio: data.profile?.bio,
    })
  }
}
